/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddProcedureTransactionViewModel } from './addProcedureTransactionViewModel';
import { PresentOnAdmission } from './presentOnAdmission';

export interface AddVisitViewModel {
  datasetId?: string;
  patientId?: string;
  financialClassId?: string;
  accidentTypeId?: string | null;
  accidentStateCode?: string | null;
  illnessInjuryDate?: string | null;
  hospitalAdmitDate?: string | null;
  hospitalDischargeDate?: string | null;
  primaryInsuranceId?: string | null;
  secondaryInsuranceId?: string | null;
  tertiaryInsuranceId?: string | null;
  delinquencyCode?: number;
  inCollectionModule?: boolean;
  isScheduledWriteoff?: boolean;
  externalId?: string | null;
  holdStatus?: string | null;
  patientStatus?: string | null;
  pwkReportTypeCode?: string | null;
  pwkTransmissionCode?: string | null;
  pwkAttachmentNumber?: string | null;
  primaryInsuranceAuthNumber?: string | null;
  secondaryInsuranceAuthNumber?: string | null;
  tertiaryInsuranceAuthNumber?: string | null;
  pendingCommit?: boolean;
  pointOfOriginId?: string | null;
  admissionTypeId?: string | null;
  dischargeStatusId?: string | null;
  admitHour?: number | null;
  dischargeHour?: number | null;
  billingNote?: string | null;
  claimNoteType1?: string | null;
  claimNote1?: string | null;
  claimNoteType2?: string | null;
  claimNote2?: string | null;
  claimNoteType3?: string | null;
  claimNote3?: string | null;
  claimNoteType4?: string | null;
  claimNote4?: string | null;
  claimNoteType5?: string | null;
  claimNote5?: string | null;
  claimNoteType6?: string | null;
  claimNote6?: string | null;
  claimNoteType7?: string | null;
  claimNote7?: string | null;
  claimNoteType8?: string | null;
  claimNote8?: string | null;
  claimNoteType9?: string | null;
  claimNote9?: string | null;
  claimNoteType10?: string | null;
  claimNote10?: string | null;
  admittingDiagnosisCodeId?: string | null;
  admittingDiagPresentOnAdmission?: string | null;
  visitReason1DiagnosisCodeId?: string | null;
  visitReason1PresentOnAdmission?: string | null;
  visitReason2DiagnosisCodeId?: string | null;
  visitReason2PresentOnAdmission?: string | null;
  visitReason3DiagnosisCodeId?: string | null;
  visitReason3PresentOnAdmission?: string | null;
  cause1DiagnosisCodeId?: string | null;
  cause1PresentOnAdmission?: string | null;
  cause2DiagnosisCodeId?: string | null;
  cause2PresentOnAdmission?: string | null;
  cause3DiagnosisCodeId?: string | null;
  cause3PresentOnAdmission?: string | null;
  drgDiagnosisCodeId?: string | null;
  drgPresentOnAdmission?: string | null;
  principalProcedureId?: string | null;
  principalProcedureDate?: string | null;
  otherProcedure1Id?: string | null;
  otherProcedure1Date?: string | null;
  otherProcedure2Id?: string | null;
  otherProcedure2Date?: string | null;
  otherProcedure3Id?: string | null;
  otherProcedure3Date?: string | null;
  otherProcedure4Id?: string | null;
  otherProcedure4Date?: string | null;
  otherProcedure5Id?: string | null;
  otherProcedure5Date?: string | null;
  occurrenceSpanCode1Id?: string | null;
  occurrenceSpan1FromDate?: string | null;
  occurrenceSpan1ToDate?: string | null;
  occurrenceSpanCode2Id?: string | null;
  occurrenceSpan2FromDate?: string | null;
  occurrenceSpan2ToDate?: string | null;
  occurrenceCode1Id?: string | null;
  occurrence1Date?: string | null;
  occurrenceCode2Id?: string | null;
  occurrence2Date?: string | null;
  occurrenceCode3Id?: string | null;
  occurrence3Date?: string | null;
  occurrenceCode4Id?: string | null;
  occurrence4Date?: string | null;
  valueCode1Id?: string | null;
  value1Amount?: number | null;
  valueCode2Id?: string | null;
  value2Amount?: number | null;
  valueCode3Id?: string | null;
  value3Amount?: number | null;
  conditionCode1Id?: string | null;
  conditionCode2Id?: string | null;
  conditionCode3Id?: string | null;
  conditionCode4Id?: string | null;
  conditionCode5Id?: string | null;
  conditionCode6Id?: string | null;
  conditionCode7Id?: string | null;
  conditionCode8Id?: string | null;
  conditionCode9Id?: string | null;
  conditionCode10Id?: string | null;
  conditionCode11Id?: string | null;
  attendingProviderId?: string | null;
  referringProviderId?: string | null;
  supervisingProviderId?: string | null;
  locationId?: string | null;
  diagnosis1Id?: string | null;
  diagnosis1PresentOnAdmission?: PresentOnAdmission;
  diagnosis2Id?: string | null;
  diagnosis2PresentOnAdmission?: PresentOnAdmission;
  diagnosis3Id?: string | null;
  diagnosis3PresentOnAdmission?: PresentOnAdmission;
  diagnosis4Id?: string | null;
  diagnosis4PresentOnAdmission?: PresentOnAdmission;
  diagnosis5Id?: string | null;
  diagnosis5PresentOnAdmission?: PresentOnAdmission;
  diagnosis6Id?: string | null;
  diagnosis6PresentOnAdmission?: PresentOnAdmission;
  diagnosis7Id?: string | null;
  diagnosis7PresentOnAdmission?: PresentOnAdmission;
  diagnosis8Id?: string | null;
  diagnosis8PresentOnAdmission?: PresentOnAdmission;
  diagnosis9Id?: string | null;
  diagnosis9PresentOnAdmission?: PresentOnAdmission;
  diagnosis10Id?: string | null;
  diagnosis10PresentOnAdmission?: PresentOnAdmission;
  diagnosis11Id?: string | null;
  diagnosis11PresentOnAdmission?: PresentOnAdmission;
  diagnosis12Id?: string | null;
  diagnosis12PresentOnAdmission?: PresentOnAdmission;
  estimatedPatientBalance?: number | null;
  visitDate?: string | null;
  holdVisit?: boolean;
  procedureTransactions?: Array<AddProcedureTransactionViewModel> | null;
}
